import { Nullable } from "common/types";

export const getPayload = (token: Nullable<string>): any => {
  if (!token) {
    return {};
  }

  try {
    const payloadData = atob(token.split(".")[1]);

    return JSON.parse(payloadData);
  } catch (_) {
    return {};
  }
};

/**
 * Checks if a JWT token has expired.
 *
 * @param token - The JWT token string to validate
 * @returns true if the token is expired or invalid, false if still valid
 *
 * @example
 * const token = "eyJhbGc...";
 * if (isExpired(token)) {
 *   console.log("Token has expired");
 * }
 */
export const isExpired = (token: Nullable<string>): boolean => {
  const payload = getPayload(token);

  // If no exp claim, consider it invalid/expired
  if (!payload.exp) {
    return true;
  }

  const expiresAt = payload.exp * 1000; // Convert seconds to milliseconds
  const now = Date.now();

  return now >= expiresAt;
};
